import type React from "react";

import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Tooltip } from "shared/atoms/Tooltip";
import { DARK_BLUE } from "theme/colors";

interface Props {
  readonly children: NonNullable<React.ReactNode>;
}

const SectionHelp: React.FC<Props> = ({ children }) => {
  return (
    <Tooltip
      title={children}
      placement="bottom"
      arrow
      slotProps={{
        tooltip: {
          sx: { xs: "calc(100% - 30px)", sm: 450 },
        },
      }}
    >
      <FontAwesomeIcon data-testid="help-icon" icon={faCircleInfo} style={{ color: DARK_BLUE[60], fontSize: 16 }} />
    </Tooltip>
  );
};

export { SectionHelp };
